import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { TerminateTreatmentModal } from './TerminateTreatmentModal.component'

const withUnmountHoc = withUnmountTransition(TerminateTreatmentModal)
export { withUnmountHoc as TerminateTreatmentModal }
